import { getExportDataList } from '@/common/api/common';
import V2Container from '@/common/components/Data/V2Container';
import V2Table from '@/common/components/Data/V2Table';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2FormRangePicker from '@/common/components/Form/V2FormRangePicker/V2FormRangePicker';
import V2SearchForm from '@/common/components/Form/V2SearchForm';
import V2Operate from '@/common/components/Others/V2Operate';
import { downloadFile, isArray, isNotEmpty, isNotEmptyAny, refactorPermissions } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { Form, Modal } from 'antd';
import dayjs from 'dayjs';
import { FC, useState } from 'react';
import styles from './index.module.less';

interface DownLoadRecordProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

/**
 * 导出记录弹窗列表
 */
const DownLoadRecord: FC<DownLoadRecordProps> = ({ visible, setVisible }) => {
  const [searchParams, setSearchParams] = useState<any>({ fileName: null, time: [] });
  const [mainHeight, setMainHeight] = useState(0);
  const [searchForm] = Form.useForm();
  const methods = useMethods({
    async loadData(params: any) {
      const res = await getExportDataList({
        ...params,
        ...searchParams,
        moduleIds: [47],
        fromExportDate: isArray(searchParams?.time) && searchParams.time[0] ? searchParams.time[0] : null,
        toExportDate: isArray(searchParams?.time) && searchParams.time[1] ? searchParams.time[1] : null,
      });
      return {
        dataSource: isArray(res?.objectList) ? res.objectList : [],
        count: res?.totalNum || 0,
      };
    },
    handleDownload(record: any) {
      downloadFile({
        name: record.fileName,
        url: record.fileUrl,
      });
    },
    handleSearch(values: any) {
      setSearchParams(values);
    },
  });
  const columns = [
    { key: 'exportTime', title: '操作时间', width: 180 },
    { key: 'menuName', title: '所属菜单', width: 180 },
    { key: 'fileName', title: '文件名称' },
    {
      key: 'statusName',
      title: '状态',
      width: 100,
      render(value: string, record: any) {
        const color = record.status === 1 ? '#FFA958' : record.status === 2 ? '#58EC9D' : '#FF7F7F';
        return <div className={styles.status}><div className={styles.circle} style={{ background: color }}/>{value}</div>;
      },
    },
    {
      key: 'permissions',
      title: '操作',
      width: 100,
      render(value: any, record: any) {
        const operateList = refactorPermissions(value);
        return isNotEmptyAny(operateList)
          ? <V2Operate operateList={operateList} onClick={(button) => methods[button?.func](record)}/>
          : '-';
      },
    },
  ];

  return (
    <Modal
      open={visible}
      width='60vw'
      footer={null}
      style={{ minWidth: 628 }}
      title={<div className={styles.modalTitle}>文件导出管理<div className={styles.tip}>(导出文件在生成后可保留30天)</div></div>}
      onCancel={() => setVisible(false)}
    >
      <V2Container
        style={{ height: '70vh', minHeight: 400 }}
        emitMainHeight={(height) => setMainHeight(height)}
        extraContent={{
          top: <V2SearchForm onSearch={methods.handleSearch} form={searchForm}>
            <V2FormInput label='文件名称' name='fileName'/>
            <V2FormRangePicker
              label='操作时间'
              name='time'
              formItemConfig={{
                getValueFromEvent: (...[, dateString]) => Array.isArray(dateString) && dateString.filter(item => isNotEmpty(item)).length ? dateString : [],
                getValueProps: (value) => ({ value: Array.isArray(value) && value.filter(item => isNotEmpty(item)).length ? [dayjs(value[0], 'YYYY-MM-DD'), dayjs(value[1], 'YYYY-MM-DD')] : undefined }),
              }}
            />
          </V2SearchForm>,
        }}
      >
        <V2Table
          rowKey='number'
          filters={searchParams}
          defaultColumns={columns}
          onFetch={methods.loadData}
          emptyRender
          voluntarilyEmpty
          scroll={{ y: mainHeight - 80 }}
        />
      </V2Container>
    </Modal>
  );
};

export default DownLoadRecord;
